'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _products = require('ifeis-isomorphic/lib/redux/selectors/products');

exports.default = function (feis_id, product_id) {
  return function (state) {

    var imagesForProduct = (0, _products.getImagesList)(state, product_id).map(function (image_id) {
      return (0, _products.getOneImage)(state, image_id);
    }) || List();

    var loading = (0, _products.productsLoading)(state) || (0, _products.imagesLoading)(state);

    return {
      loading: loading,
      product: (0, _products.getOneProduct)(state, product_id).setIn(['images'], imagesForProduct)
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./product-list/edit-product/mapStateToController.js
// module id = 493
// module chunks = 0